import React from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

export const SelectInput = ({ label, value, options, onChange, error }) => (
  <FormControl style={{ width: "100%", marginTop: '16px', marginBottom: '8px' }} error={error} variant="outlined">
    <InputLabel id="select-label">{label}</InputLabel>
    <Select
      value={value}
      onChange={event => onChange(event.target.value)}
      id="select"
      label={label}
    >
      {options.map(option => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);
